import React, { useEffect, useMemo } from 'react';
import "../style/Cart-Checkout.css";
import { useTranslation } from 'react-i18next';
import { useCurrency } from '../contexts/CurrencyContext';

const CheckoutSummary = ({ asyncCartItems, taxes, selectedShippingOption, totalCost, isTinyMobileView, couponAmount, giftcardAmount, freeShipping, onPreTotalChange }) => {
    const { t } = useTranslation();
    const { selectedCurrency, currencySymbol, formatPrice, calculateConvertedTotalPrice } = useCurrency();

    const preTotal = useMemo(() => {
        return asyncCartItems.reduce((total, item) => total + (calculateConvertedTotalPrice(item.prcbdn) * item.numberOfItems), 0);
    }, [asyncCartItems]);

    useEffect(() => {
        onPreTotalChange?.(preTotal);
    }, [preTotal, onPreTotalChange]);

    return ( // Ensure you have a return statement here
        <div className="checkout-summary">
            <div class="wrapper-confirm">
                <h2 className="title-padding-confirm">{t("checkout.checkoutTitle")}</h2>

                <div class="left-padded-horizontal-container">
                    <div class="small-horizontal-fit"></div>
                </div>
            </div>

            <ul>
                {asyncCartItems.map((item, index) => (
                    <li key={index} className="order-item order-item-small">
                        <img className="cart-image-preview cart-image-phone" src={item.previewUrl} alt={item.name} />
                        <div className="order-item-details">
                            <p className="order-item-name"><strong>{item.name}</strong></p>
                                <div className="order-details column order-details-small">
                                    <p>{t("checkout.priceLabel")}: {currencySymbol}{formatPrice(calculateConvertedTotalPrice(item.prcbdn))}</p>
                                    {item.selectedSize && item.selectedSize.description && item.selectedSize.description !== "N/A" && (
                                        <p>{t("checkout.sizeLabel")}: {t("options.size" + item.selectedSize?.description)}</p>
                                    )}
                                    {item.selectedFirmness && item.selectedFirmness !== "N/A" && (
                                        <p>
                                            {t("checkout.softnessLabel")}: {typeof item.selectedFirmness?.description === "string"
                                            ? t("options.firmness" + item.selectedFirmness.description)
                                            : t("options.firmness" + item.selectedFirmness) || "N/A"}
                                        </p>
                                    )}
                                    {item.selectedColor && item.selectedColor.description !== "N/A" && (
                                        <p>{t("checkout.colorLabel")}: {item.selectedColor?.description}</p>
                                    )}
                                    {item.selectedOption && item.selectedOption.description !== "N/A" && (
                                        <p>{t("checkout.optionsLabel")}: {t("options.option" + item.selectedOption?.description)}</p>
                                    )}
                                    {item.numberOfItems > 1 && (
                                        <p>{t("checkout.quantityLabel")}: {item.numberOfItems}</p>
                                    )}
                                </div>                         
                        </div>
                    </li>
                    
                ))}
            </ul>


            <h3>{t("checkout.summaryLabel")}</h3>
            <p>{t("checkout.subtotalLabel")}: {currencySymbol}{formatPrice(preTotal)} {selectedCurrency}</p>
            {couponAmount && (
                <p>
                    {t("checkout.discountLabel")}: -{currencySymbol}{formatPrice(couponAmount/100 * preTotal)} {selectedCurrency}
                    ({couponAmount}% OFF)
                </p>
            )}
            {giftcardAmount && (
                <p>
                    {t("checkout.giftcardLabel")}: -{currencySymbol}{formatPrice(giftcardAmount)} {selectedCurrency}
                </p>
            )}

            {/* {selectedShippingOption ? (
                <p>
                    Taxes: ${parseFloat(taxes).toFixed(2)}
                </p>
            )  : (
                <p>
                    Taxes: Calculating...
                </p>
            )} */}
            {selectedShippingOption ? (
                <p>
                    {t("checkout.shippingLabel")}: {freeShipping ? (
                        <>
                            <span className="free-shipping-price"> {currencySymbol}{formatPrice(selectedShippingOption.price)}</span>
                            {" "}<span className="free-shipping-label">{t("checkout.freeLabel")}</span>
                        </>
                    ) : (
                        <>{currencySymbol}{formatPrice(selectedShippingOption.price)} {selectedCurrency}</>
                    )}
                </p>
            ) : (
                <p>
                    {t("checkout.shippingLabel")}: {t("checkout.calculatingLabel")}...
                </p>
            )}
                <h3>
                    {t("checkout.totalLabel")}: {selectedShippingOption && preTotal ? `${currencySymbol}${formatPrice(totalCost)} ${selectedCurrency}` :t("checkout.calculatingLabel")}
                </h3>
        </div>
    );
};

export default CheckoutSummary;
